import { Layout } from 'components/atoms'
import { InputBuild, SelectBuild } from 'components/molecules'
import { LocationsDTO } from 'models'
import React, { useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormDebtorValue } from './form'
import { ViewDebtorFormProps } from './interfaces'

const ViewDebtorForm: React.FC = () => {
    const { register, watch } = useFormContext<{
        debtor: ViewDebtorFormProps
    }>()

    const [location] = useState<LocationsDTO[]>([])

    const form = useMemo(() => FormDebtorValue(location), [location])

    return (
        <Layout
            full
            type="container"
            display="grid"
            gap={8}
            data-testid="form-container"
        >
            <Layout type="row" gutter={{ y: 1.5 }} data-testid="form-fields">
                {form.map(({ layout, input, select }, key) => (
                    <Layout {...layout} key={key}>
                        {select ? (
                            <SelectBuild
                                {...select}
                                {...register(`debtor.${select.id}`)}
                                value={watch(`debtor.${select.id}`) as string}
                                isDisable={true}
                            />
                        ) : (
                            input && (
                                <InputBuild
                                    {...input}
                                    {...register(`debtor.${input.id}`)}
                                    value={
                                        watch(`debtor.${input.id}`) as string
                                    }
                                    isDisable={true}
                                />
                            )
                        )}
                    </Layout>
                ))}
            </Layout>
        </Layout>
    )
}

export default ViewDebtorForm
